import React  from "react";
import ReactModal from "react-modal";
import { Input, Select  } from "@components/form";
import { Draggable, Pagination} from "@components";
import { FormProvider } from "react-hook-form";
import { useLectureInvCompanyModal } from "@hooks";

function LectureInvCompanyModal({ isOpen, onClose, onConfirm }) {

  const position = Draggable({ isOpen, dragHandle: ".modal-header" });

  const containerStyle = {
    maxWidth: "800px",
    minWidth: "800px",
    maxHeight: "700px",
    minHeight: "700px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  const {
    methods, data, onSubmit, selectedItem,
    handlePageChange, handleSelectItem,
    pageIndex, recordCountPerPage,
  } = useLectureInvCompanyModal();


  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="modal-overlay"
      className="modal-wrap"
    >
      <div className="modal-container" style={containerStyle}>
          <div className="modal-header"  style={{ cursor: "move" }}>
            <h5>사업장 추가</h5>
            <button type="button" className="modal-btn-close" onClick={onClose}>
              <span className="modal-btn-span">X</span>
            </button>
          </div>
        <FormProvider {...methods}>  
        <div className="modal-content">
          <div className="search-wrap">
            <div className="search-row">
              <div className="search-item">
                <Select
                  name="searchCnd"
                  options={[
                    { key: "0", name: "사업자등록번호" },
                    { key: "1", name: "사업장명" },
                    { key: "2", name: "대표자명" },
                  ]}
                  defaultOption="선택"
                  className="input-select"
                />
                <Input
                  name="searchWrd"
                  placeholder="검색어를 입력하세요"
                  className="input-search"
                  style={{ width: "250px" }}
                />
              </div>
              <div className="search-btn-container">
                <button type="button" className="btn-search" onClick={methods.handleSubmit(onSubmit)} >조회</button>
              </div>
            </div>
          </div>

           <div className="section-tit-wrap" style={{display:"flex", justifyContent:"space-between"}}>
              <h3 className="border-left-primary">
                &nbsp;사업장 목록
                <span className="total-txt">
                  {" "} | 총 <span className="red">{data?.totalCount}건</span>
                </span>
                 
              </h3>
            </div>
            <div className="table-container">
            <table className="table-list" style={{ width: "100%" }}>
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "35%" }} />
                <col style={{ width: "30%" }} />
                <col style={{ width: "30%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th></th>
                  <th>사업자등록번호</th>
                  <th>사업장명</th>
                  <th>대표자명</th>
                </tr>
              </thead>
              <tbody>
              {data?.resultList && data.resultList.length > 0 ? (
                    data.resultList.map((item) => {
                      return (
                        <tr
                            key={item.bizRegNo}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleSelectItem(item)
                            }}
                        >
                          <td>
                          <input 
                              type="checkbox" 
                              checked={selectedItem?.bizRegNo === item.bizRegNo}
                              readOnly
                          />
                          </td>
                          <td style={{textAlign:"left"}}>{item.bizRegNo}</td>
                          <td style={{textAlign:"left"}}>{item.companyNm}</td>
                          <td> {item.representNm}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4} style={{ textAlign: "center" }}>
                        조회 결과가 없습니다.
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>

          </div>
          {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                <Pagination
                    totalPages={Math.ceil(
                    data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                    )}
                    currentPage={pageIndex}
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={recordCountPerPage}
                />
              )}
        </div>

        </FormProvider>
        <div className="modal-btn-wrap btn-right-box">
            <ul>
                <li><button type="button" className="btn-cancel" onClick={onClose}>닫기</button></li>
                <li>
                  <button
                    type="button"
                    className="btn-save"
                    onClick={() => {
                      if (!selectedItem) return alert("사업장을 선택하세요");
                      onConfirm(selectedItem); 
                    }}>
                    선택완료
                  </button>
                </li>
            </ul>
        </div>
      </div>
    </ReactModal>
  );
}

export {LectureInvCompanyModal};
